import { exhaustMap, interval, lastValueFrom, Observable, share, startWith, Subscriber, takeWhile } from 'rxjs';
import { TaskParams } from './';
import { AbstractTask } from './AbstractTask';

export class ObserverTask extends AbstractTask {
    readonly observer: Observable<any>;
    private subscriber: Subscriber<any>;

    constructor(params: TaskParams) {
        super(params);
        this.observer = new Observable((subscriber) => {
            this.subscriber = subscriber;
        });
    }

    public async startPolling(poolingInterval: number, maxRetry: number, startAfterInterval = true) {
        let operators = [
            startAfterInterval ? undefined : startWith(0),
            takeWhile((value) => {
                if (this.cancelled) {
                    return false;
                }
                if (this.poolCount >= maxRetry) {
                    throw `maximum ${maxRetry} retries reached`;
                }
                return true;
            }),
            exhaustMap(() => this.poll()),

            share(),
        ];
        operators = operators.filter((operator) => !!operator);
        // @ts-ignore
        const observable = interval(poolingInterval).pipe(...operators);
        let subscription = observable.subscribe({
            next: (x) => this.subscriber.next(x),
            error: (err) => this.subscriber.error(err),
        });
        try {
            await lastValueFrom(observable);
        } catch (e) {}
    }
}
